<script>
    import TaskGroupsCollection from 'collections/TaskGroupsCollection'
    import {get, writable} from 'svelte/store';
    import ContentNavigationBar from 'views/components/contentNavigationBar/ContentNavigationBar.svelte'
    import ContentNavigationBarItem from 'views/components/contentNavigationBar/ContentNavigationBarItem.svelte'
    import Icon from 'views/components/icon/Icon.svelte'

    export let taskGroups = new TaskGroupsCollection()
    export let initialActiveItemKey = -1

    export const activeItemKey = writable(initialActiveItemKey)

    export function getActiveItem() {
        return get(activeItemKey)
    }

    export function setActiveItem(newActiveItemKey) {
        activeItemKey.set(Math.min(taskGroups.size(), Math.max(-1, newActiveItemKey)))
    }

    export function toPreviousItem() {
        setActiveItem(get(activeItemKey) - 1)
    }
    export function toNextItem() {
        setActiveItem(get(activeItemKey) + 1)
    }
</script>

{#if !window.ISMOBILE}
    <div class="navigation-bar-outer">
        <ContentNavigationBar>
            <ContentNavigationBarItem
                itemKey={-1}
                {activeItemKey}
            >
                <Icon name="assignment"></Icon>
            </ContentNavigationBarItem>
            {#each taskGroups.models as taskGroup (taskGroup.id)}
                <ContentNavigationBarItem
                    itemKey={taskGroup.get('sequence')}
                    {activeItemKey}
                    model={taskGroup}
                >
                    {@const contentDomain = taskGroup.getContentDomainItem()?.abbreviation}

                    <div class="index">
                        {taskGroup.get('index')}

                        {#if contentDomain}
                            <div class="content-domain">{contentDomain}</div>
                        {/if}
                    </div>
                </ContentNavigationBarItem>
            {/each}
            <ContentNavigationBarItem
                itemKey={taskGroups.size()}
                {activeItemKey}
            >
                <Icon name="checkmark-circle"></Icon>
            </ContentNavigationBarItem>
        </ContentNavigationBar>
    </div>
{/if}

<style lang="scss">/*
* Scut, a collection of Sass utilities
* to ease and improve our implementations of common style-code patterns.
* v1.0.1
* Docs at http://davidtheclark.github.io/scut
*/
/* TODO implement tooltip arrow */
.navigation-bar-outer {
  grid-area: menu-right;
  position: sticky;
  top: 0;
  height: 100vh;
  /* stylelint-disable-next-line declaration-block-no-duplicate-properties */
  height: 100dvh;
  z-index: 5000;
  -webkit-overflow-scrolling: touch;
}

:global(body.has-fixed-sidebar) .navigation-bar-outer {
  /* Hide navigation bar when fixed sidebar is active to save on visual clutter */
  display: none;
}

.index {
  text-align: center;
  padding-top: 4px;
  padding-bottom: 4px;
  width: 100%;
}

.content-domain {
  font-size: 12px;
  margin-top: 2px;
  margin-bottom: -4px;
  padding-top: 2px;
  padding-bottom: 2px;
  border-bottom-left-radius: 11px;
  border-bottom-right-radius: 11px;
  background-color: rgba(44.88, 123.42, 179.52, 0.1);
  color: hsl(205, 60%, 44%);
  text-transform: uppercase;
}

:global(button.is-active) .content-domain {
  color: #fff;
}</style>
